import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'

export default createUseStyles((theme: Theme) => ({
  practitionerNameContainer: {
    marginBottom: '2px',
  },
  selectPractitionerButton: {
    borderRadius: '100px/100px',
    border: `1px solid ${theme.palette.primary.main}`,
    padding: '6px 0px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pencilIcon: {
    width: 16,
    height: 16,
  },
}))

export const practitionerInfoContainer = (hideBottomMargin?: boolean) => ({
  display: 'flex',
  gap: '16px',
  marginBottom: hideBottomMargin ? undefined : '24px',
})
